import React from 'react'
import { Button, Loader } from 'semantic-ui-react'

import AuthenticationShell from 'shared/components/AuthenticationShell'
import { StatusIconTone } from 'shared/components/AuthenticationShell/StatusIcon'
import Page from 'shared/components/Page'
import Title from 'shared/components/Title'

import ConfirmScreen from './ConfirmScreen'
import { ConnectScreen } from './types'

const MCP_HELP_ARTICLE_URL =
  'https://help.simplesat.io/en/articles/15828970-simplesat-mcp-integration'

export interface OAuthConnectProps {
  screen: ConnectScreen | null
  aiAppName: string
  onContinue: () => void
  onSwitchAccount: () => void
  onCreateWorkspace: () => void
}

export default function OAuthConnect(props: OAuthConnectProps) {
  return (
    <Page>
      <Title title={`Connect ${props.aiAppName}`} />
      <ConnectScreenContent {...props} />
    </Page>
  )
}

function ConnectScreenContent({
  screen,
  aiAppName,
  onContinue,
  onSwitchAccount,
  onCreateWorkspace,
}: OAuthConnectProps) {
  if (!screen) {
    return null
  }
  switch (screen.kind) {
    case 'confirm':
      return (
        <ConfirmScreen
          email={screen.email}
          isConnecting={screen.isConnecting}
          onContinue={onContinue}
          onSwitchAccount={onSwitchAccount}
        />
      )
    case 'connecting':
      return <WaitScreen>Connecting…</WaitScreen>
    case 'no-workspaces':
      return (
        <StatusScreen
          tone="info"
          icon={<i className="fas fa-layer-group" />}
          title="No workspaces yet"
          description={
            <>
              Create a workspace or ask your admin to invite you.
              <br />
              Then try again on {aiAppName}.
            </>
          }
        >
          <Button primary fluid size="large" type="button" onClick={onCreateWorkspace}>
            Create workspace
          </Button>
        </StatusScreen>
      )
    case 'error':
      return (
        <StatusScreen
          tone="negative"
          icon={<i className="fas fa-square-exclamation" />}
          title="Connection failed"
          description={
            <>
              Simplesat MCP couldn&apos;t connect to {aiAppName}.
              <br />
              Try to connect again, or{' '}
              <a href={MCP_HELP_ARTICLE_URL} target="_blank" rel="noreferrer">
                contact Simplesat support
              </a>
              .
            </>
          }
        />
      )
  }
}

interface WaitScreenProps {
  children: React.ReactNode
}

function WaitScreen({ children }: WaitScreenProps) {
  return <AuthenticationShell icon={<Loader active inline="centered" />} subHeaderText={children} />
}

interface StatusScreenProps {
  tone: StatusIconTone
  icon: React.ReactNode
  title: string
  description: React.ReactNode
  children?: React.ReactNode
}

function StatusScreen({ tone, icon, title, description, children }: StatusScreenProps) {
  return (
    <AuthenticationShell
      headerText={title}
      subHeaderText={description}
      icon={<AuthenticationShell.StatusIcon tone={tone}>{icon}</AuthenticationShell.StatusIcon>}
    >
      {children}
    </AuthenticationShell>
  )
}



// WEBPACK FOOTER //
// ./src/pages/OAuthConnect/index.tsx